import { Component, ElementRef, EventEmitter, HostBinding, HostListener, Input, OnInit, Output, ViewChild } from "@angular/core";

@Component({
  selector: "common-drag-drop-file-upload",
  templateUrl: "./drag-drop-file-upload.component.html",
  styleUrls: ["./drag-drop-file-upload.component.scss"],
})
export class DragDropFileUploadComponent implements OnInit {
  @ViewChild("fileInput") fileInput: ElementRef;

  @Input() acceptedFileTypes: string = ".pdf, .doc, .docx, .png, .jpg, .jpeg";

  file: File;
  fileOver: boolean;

  @Output() fileChange = new EventEmitter<File>();

  // Dragover listener
  @HostListener("dragover", ["$event"]) onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = true;
  }

  // Dragleave listener
  @HostListener("dragleave", ["$event"]) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
  }

  // Drop listener
  @HostListener("drop", ["$event"]) public ondrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
    let files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.onFileSelect(files);
      console.log(files);
    }
  }

  constructor() {}

  ngOnInit(): void {}

  dropZoneClick() {
    this.fileInput.nativeElement.click();
  }

  onFileSelect(files: File[]) {
    if (files.length == 0) {
      return;
    }

    if (files.length > 1) {
      alert("Only one file is required.");
      return;
    }

    this.file = files[0];
    this.fileChange.emit(this.file);
  }

  deleteFile() {
    this.file = null;
    this.fileChange.emit(this.file);
  }
}
